<template>
    <div class="card page-height">
        <div class="card-header">
            <h4 class="card-title mb-0">Create Order</h4>
        </div>
        <div class="card-body form-steps">
            <div class="select-step">
                <!-- progressbar -->
                <ul id="progressbar" class="mb-3">
                    <li class="active"><span>Select Customer</span></li>
                    <li><span>Select Quotes</span></li>
                    <li><span>Select Products</span></li>
                    <li><span>Provide Other Info</span></li>
                </ul>
                <!-- fieldsets -->
                <fieldset class="search">
                    <div class="row">
                        <div class="col-sm-7 col-md-7">
                            <form class="form-inline" action="" @submit.prevent="search()">
                                <div class="autocomplete-form">
                                    <autocomplete
                                        :source="customerSearchEndpoint"
                                        :requestHeaders="authHeaders"
                                        :resultsFormatter="resultsFormatter"
                                        ref="autocomplete"
                                        placeholder="Quick Search"
                                        input-class="form-control"
                                        @selected="selectFilterCustomer($event)"
                                        @clear="selectFilterCustomer(null)"
                                    />
                                    <!--<input v-model="search_filter" type="text" class="form-control" placeholder="Quick Search">
                                    <button class="btn btn-outline-secondary custom-btn" type="button" @click.prevent="search">
                                        <i class="fa fa-search" aria-hidden="true"></i></button>-->

                                </div>
                            </form>
                        </div>
                        <div class="col-sm-5 col-md-5">
                            <div class="title-right new-custom-sec2 float-right">
                                <!--<router-link :to="{ name: 'selectProducts'}" class="btn skip-btn">SKIP</router-link>
                                <router-link :to="{ name: 'selectQuotes'}" class="btn custom-btn ml-3" v-if="totalQuotations > 0"
                                            :class="[newOrder.customer_id == null ? 'disabled':'']">Next
                                </router-link>
                                <router-link :to="{ name: 'selectProducts'}" class="btn custom-btn ml-3" v-else
                                            :class="[newOrder.customer_id == null ? 'disabled':'']">Next
                                </router-link>-->
                                <button type="button" class="btn custom-btn" data-toggle="modal" data-target="#customerAddModal">
                                        <i class="ri-add-circle-line align-middle pe-1"></i> New Customer
                                    </button>
                                <!-- <router-link :to="{ name: 'addCustomer'}" class="btn custom-btn">New Customer</router-link> -->
                            </div>
                        </div>
                    </div>
                </fieldset>
                <div class=" table-margin customer-section-step1">
                    <Customers :selectedCustomer="newOrder.customer_id" :search_filter="search_filter"
                            @selectCustomer="selectCustomer($event)" :bus="bus" ref="customerList"></Customers>
                </div>


            </div>
            <CustomerAddModal :bus="bus" @customerDataSaved="customerDataSaved($event)"></CustomerAddModal>
        </div>
        <div class="card-footer">
            <div class="btnrow text-right">
                    <!--<router-link :to="{ name: 'selectProducts'}" class="btn skip-btn">SKIP</router-link>-->
                    <router-link :to="{ name: 'selectQuotes'}" class="btn  btn-success right btn-label ml-3" v-if="totalQuotations > 0"
                                :class="[newOrder.customer_id == null ? 'disabled':'']"><i class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>Next
                    </router-link>
                    <router-link :to="{ name: 'selectProducts'}" class="btn  btn-success right btn-label ml-3" v-else
                                :class="[newOrder.customer_id == null ? 'disabled':'']"><i class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>Next
                    </router-link>

                </div>
        </div>
    </div>
</template>

<script>

import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import Customers from "../../components/Customers";
import Vue from "vue";
import SearchAutocomplete from "../../components/SearchAutocomplete";
import Autocomplete from 'vuejs-auto-complete'
import CustomerAddModal from "../../components/CustomerAddModal";

export default {
    name: "SelectCustomer",
    components: {
        Customers,
        Autocomplete,
        SearchAutocomplete,
        CustomerAddModal
    },
    created() {
        if (localStorage.getItem('token')) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        //this.setNewOrder(this.newOrder);
        if (this.salesOrderState) {
            this.newOrder = this.salesOrderState.newOrder;
            this.totalQuotations = 0;
            if(this.newOrder.customer_id) {
                this.checkQuotations();
            }
        }
    },
    beforeRouteLeave (to, from , next) {
        if(to.name == 'selectQuotes' || to.name == 'selectProducts') {
            next();
        } else {
            const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
            if (answer) {
                next();
            } else {
                next(false);
            }
        }
    },
    mounted() {

    },
    beforeMount() {
        //window.addEventListener("beforeunload", this.preventNav)
    },

    beforeDestroy() {
        /*Vue.$confirm({
            title: 'Are you sure?',
            message: 'You sure you want to leave and delete the order?',
            button: {
                yes: 'Leave',
                no: 'Stay on page'
            },
            callback: confirm => {
                if (confirm) {
                    return;
                }

            }
        });
        window.removeEventListener("beforeunload", this.preventNav);*/
    },

    data() {
        return {
            bus: new Vue(),
            newOrder: {
                id: null,
                is_draft: 0,
                is_stocking: 0,
                stocking_terms: null,
                warehouses: [],
                customerWarehouses: [],
                billTo: [],
                customer_id: null,
                sales_rep_id: null,
                order_number: null,
                order_date: null,
                customer_terms: null,
                purchase_terms: null,
                customer_po: null,
                eta: null,
                fob: null,
                notes: null,
                customer_notes: null,
                quotations: [],
                customer: {
                    quotations_after_sent_to_customer: []
                },
                products:[],
                selectedProducts: [],
            },
            search_filter: null,
            totalQuotations: 0,
            saveDone: false,
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setNewOrder',
            'setOrdersLoading',
            'setQuotationLoading'
        ]),
        preventNav(event) {
            if (this.saveDone) {
                return;
            }
            event.preventDefault()
            event.returnValue = ""
        },
        customerDataSaved(customer){
            this.bus.$emit('getCustomers');
            this.newOrder.customer_id = null;
            this.newOrder.quotations = [];
            if (customer) {
                this.newOrder.customer_id = customer.id;
                this.newOrder.customer = customer;
                this.newOrder.sales_rep_id = customer.sales_rep ? customer.sales_rep.id : null;

                this.checkQuotations();
            }
            //alert(customer);
        },
        selectCustomer(c) {
            this.newOrder.customer_id = null;
            this.newOrder.quotations = [];
            if (c) {
                console.log("customer data",c);
                this.newOrder.customer_id = c.id;
                this.newOrder.customer = c;
                this.newOrder.sales_rep_id = c.sales_rep ? c.sales_rep.id : null;

                this.checkQuotations();
            }

            this.setNewOrder(this.newOrder);
        },
        checkQuotations() {
            let self = this;
            this.setQuotationLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('quotations.index', {
                page:1,
                search_filter:null,
                customer_id: this.newOrder.customer_id,
                so_sent_to_customer: true
            }), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        //console.log(data);
                        this.totalQuotations = data.data.quotations.total;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setQuotationLoading(false);

                });
        },
        search() {
            this.bus.$emit('getCustomers')
        },
        selectFilterCustomer(event) {
            // console.log(event);
            this.search_filter = event != null ?event.selectedObject.name : '';
            setTimeout(() => {
                this.search();
            }, 500);
        },
        customerSearchEndpoint (input) {
            return window.route('customers.index',{page: 1, per_page: 20, search_filter: input} );
        },
        resultsFormatter(result){
            if(!result.errorMessage && result.data.customers.data.length) {
                let customers = [];
                result.data.customers.data.forEach((x) => {
                    customers.push({
                       id: x.id,
                       name: x.company_name
                    });
                });

                return customers;
            }
            return [];
        },
        formattedDisplay (result) {
            return result.name + ' [' + result.id + ']'
        }
    },
    watch: {},
    computed: {
        ...mapState([
            'userState',
            'salesOrderState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'ordersLoading',
            'getSalesOrderState'
        ]),
        authHeaders () {
            return {
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
            }
        },
    }
}
</script>

<style scoped>

</style>
